export default __webpack_public_path__ + "static/media/bare-feet.3cff8bb5.svg";